import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";
import ReceiptIcon from "@mui/icons-material/Receipt";
import InventoryIcon from "@mui/icons-material/Inventory";
import CollectionsIcon from "@mui/icons-material/Collections";
import CategoryIcon from "@mui/icons-material/Category";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { Link } from "react-router-dom";
import "./AdminSidebar.css";

const AdminSidebar = () => {
  return (
    <div className="admin-sidebar-container">
      <span>
        <small>MAIN</small>
      </span>
      <ul>
        <li>
          <Link to="/admin-dashboard">
            <HomeIcon className="me-2 icon" />
            Dashboard
          </Link>
        </li>
      </ul>
      <span>
        <small>LISTS</small>
      </span>
      <ul>
        <li>
          <Link to="/admin-orders">
            <ReceiptIcon className="me-2 icon" />
            Orders
          </Link>
        </li>
        <li>
          <Link to="/admin-products">
            <InventoryIcon className="me-2 icon" />
            Products
          </Link>
        </li>
        <li>
          <Link to="/admin-wallet-history">
            <AccountBalanceWalletIcon className="me-2 icon" />
            Wallet History
          </Link>
        </li>        
        <li>
          <Link to="/admin-users">
            <GroupIcon className="me-2 icon" />
            Customers
          </Link>
        </li>
        <li>
          <Link to="/admin-gallery">
            <CollectionsIcon className="me-2 icon" />
            Gallery
          </Link>
        </li>
        <li>
          <Link to="/admin-product-category">
            <CategoryIcon className="me-2" />
            Product Category
          </Link>
        </li>        
        <li>
          <Link to="/admin-banners">
            <ViewCarouselIcon className="me-2" />
            Banners
          </Link>
        </li>        
        <li>
          <Link to="/admin-leaderboard">
            <ViewCarouselIcon className="me-2" />
            Leaderboard
          </Link>
        </li>
        <li>
          <Link to="/admin-subscription-plans">
            <WorkspacePremiumIcon className="me-2 icon" />
            Subscription Plans
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default AdminSidebar;
